export default "__VITE_ASSET__c3514755__"